import { QueryClient } from '@tanstack/react-query'
import { financialStatementsKeys } from '../../financialStatements/queries/financialStatementsQueryKeys'
import customReportQueryKeys from '../../customReport/queries/customReportQueryKeys'

const invalidateReportQueries = (queryClient: QueryClient) => {
  queryClient.invalidateQueries({ queryKey: financialStatementsKeys.all })
  queryClient.invalidateQueries({ queryKey: customReportQueryKeys.sections() })
}

export default invalidateReportQueries
